// extracted by mini-css-extract-plugin
export var actionButton = "_qe-0";
export var actionMenuContainer = "_qe-i";
export var bubble = "_qe-2";
export var bubbleActionMenu = "_qe-j";
export var bubbleContext = "_qe-6";
export var bubbleItems = "_qe-7";
export var customer = "_qe-3";
export var divider = "_qe-8";
export var fileList = "_qe-9";
export var hiddenComment = "_qe-o";
export var infoAbove = "_qe-a";
export var internal = "_qe-4";
export var lightActionButton = "_qe-1";
export var link = "_qe-b";
export var merchant = "_qe-5";
export var message = "_qe-c";
export var profilePicture = "_qe-e";
export var quillToolbarContainer = "_qe-f";
export var senderDate = "_qe-g";
export var senderDateCustomer = "_qe-h";
export var senderName = "_qe-d";
export var time = "_qe-k";
export var uploadedImage = "_qe-l";
export var username = "_qe-m";
export var xsmall = "_qe-n";